import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheck, ArrowRight, User, Lock } from 'lucide-react';
export function AdminLogin() {
  const navigate = useNavigate();
  const handleSignIn = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/admin');
  };
  return <div className="min-h-screen flex items-center justify-center bg-club-green py-12 px-4 relative overflow-hidden" data-id="element-426">
      {/* Decorative pattern */}
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none" data-id="element-427">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-428">
          <defs data-id="element-429">
            <pattern id="admin-pattern" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-430">
              <path d="M0 40L40 0H20L0 20M40 40V20L20 40" fill="currentColor" fillOpacity="0.5" data-id="element-431" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#admin-pattern)" data-id="element-432" />
        </svg>
      </div>

      <motion.div className="max-w-md w-full bg-white rounded-sm shadow-xl p-10 relative z-10" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} data-id="element-433">
        <div className="text-center mb-8" data-id="element-434">
          <div className="mx-auto h-12 w-12 bg-club-green rounded-full flex items-center justify-center mb-4" data-id="element-435">
            <ShieldCheck className="h-6 w-6 text-club-gold" data-id="element-436" />
          </div>
          <h1 className="text-3xl font-serif text-club-green mb-1" data-id="element-437">
            Admin Console
          </h1>
          <p className="text-sm text-club-ink/60" data-id="element-438">
            Membership administration for Andhra Social &amp; Cultural
            Association
          </p>
        </div>

        <form className="space-y-5" onSubmit={handleSignIn} data-id="element-439">
          <div data-id="element-440">
            <label htmlFor="admin-user" className="block text-sm font-medium text-club-ink mb-1" data-id="element-441">
              Staff ID / Email
            </label>
            <div className="relative" data-id="element-442">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-443">
                <User className="h-5 w-5 text-club-ink/40" data-id="element-444" />
              </div>
              <input id="admin-user" type="text" className="block w-full pl-10 pr-3 py-3 border border-club-border rounded-sm focus:outline-none focus:ring-1 focus:ring-club-gold focus:border-club-gold sm:text-sm bg-club-canvasAlt/50" placeholder="admin@andhraassociation.com" data-id="element-445" />
            </div>
          </div>

          <div data-id="element-446">
            <label htmlFor="admin-pass" className="block text-sm font-medium text-club-ink mb-1" data-id="element-447">
              Password
            </label>
            <div className="relative" data-id="element-448">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-449">
                <Lock className="h-5 w-5 text-club-ink/40" data-id="element-450" />
              </div>
              <input id="admin-pass" type="password" className="block w-full pl-10 pr-3 py-3 border border-club-border rounded-sm focus:outline-none focus:ring-1 focus:ring-club-gold focus:border-club-gold sm:text-sm bg-club-canvasAlt/50" placeholder="••••••••" data-id="element-451" />
            </div>
          </div>

          <button type="submit" className="w-full btn-primary py-3 flex justify-center items-center gap-2" data-id="element-452">
            Sign in to Console <ArrowRight size={16} data-id="element-453" />
          </button>
        </form>

        <p className="mt-6 text-center text-xs text-club-ink/40" data-id="element-454">
          Authorised personnel only.
        </p>
      </motion.div>
    </div>;
}